(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ReservationRailComponentDetails',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		var form_name           = 'form_component_data[ReservationRailComponentDetails]';
		var label_name          = 'reservationrailcomponentdetails';
		var departure_container = $('.departure-container');
		var return_container    = $('.return-container');
		var p2p_type            = 'roundtrip';
		var form_action         = departure_container.data('action');

		// change p2p_type when we load the form
		// and remove the return part of the form from the DOM
		// but save a referece if we need to add it later
		if ($('#' + label_name + '-point_to_point_type-1').is(':checked')) {
			p2p_type = 'oneway';
			return_container.detach().removeClass('hidden');
		}

		// show the copy details checkbox on the return train
		if (form_action === 'add') {
			showReturnTrainCheckbox();
		}

		// when changing the p2p_type radio input
		// removes/inserts the "Return" portion of the trains
		$('input[type="radio"][name="' + form_name + '[point_to_point_type]"]').change(function onPointTypeChange()
		{
			p2p_type = $(this).val();

			if (p2p_type === 'oneway') {
				return_container = $('.return-container');
				return_container.detach();
			}

			if (p2p_type === 'roundtrip') {
				departure_container.after(return_container);
				showReturnTrainCheckbox();
				addReturnTrainCheckboxEvent();
				addConnectingTrainEvent();
			}
		});

		// when changing the rail_type radio input
		// toggle the rail pass dates, p2p types and departure/return legs
		$('input[type="radio"][name="' + form_name + '[rail_type]"]').change(function onRailTypeChange()
		{
			$('.rail-pass-date').toggleClass('hidden');
			$('.p2p-type').toggleClass('hidden');
			$('.departure-container').toggleClass('hidden');
			$('.return-container').toggleClass('hidden');

			showReturnTrainCheckbox();
		});

		// clicking on copy train info checkbox
		// on the return train 1
		addReturnTrainCheckboxEvent();

		// when the start datepicker changes
		// update the end date accordingly
		$('#' + label_name + '-rail_pass_start_date').on('dp.change', function onRailPassDpChange(event)
		{
			if (event.date) {
				$('#' + label_name + '-rail_pass_end_date')
					.data('DateTimePicker')
					.date(event.date);
			}
		});

		// Toggle final payment date fields
		$('#reservationrailcomponentdetails-set_final_payment_date').on('change', function change(e) {
			if ($(this).prop('checked') === true) {
				$form.find('.final-payment-date').removeClass('hidden');
				$form.find('.soft-payment-date').removeClass('hidden');
			} else {
				$form.find('.final-payment-date').addClass('hidden');
				$form.find('.soft-payment-date').addClass('hidden');
			}
		});

		// Auto-adjust final payment soft date when final payment due date is set
		$('#reservationrailcomponentdetails-final_payment_date').on('dp.change', function dateChange(event) {
			var $final_payment_date     = $(this),
				$soft_payment_date      = $('#reservationrailcomponentdetails-soft_payment_date'),
				soft_payment_date       = null,
				formatted_soft_date     = null,
				new_soft_payment_date   = null,
				formatted_new_soft_date = null;

			if ($final_payment_date.val() === $final_payment_date.data('current-value')) {
				return;
			}

			$final_payment_date.data('current-value', $final_payment_date.val());

			if (event.date) {
				soft_payment_date = $soft_payment_date.data('DateTimePicker');

				if (soft_payment_date && soft_payment_date.date()) {
					formatted_soft_date = soft_payment_date.date().format("M/D/YYYY");
				} else {
					formatted_soft_date = "(No date entered)";
				}

				new_soft_payment_date = event.date;
				new_soft_payment_date.subtract($soft_payment_date.data('soft-date-days'), 'days');
				formatted_new_soft_date = new_soft_payment_date.format('M/D/YYYY');

				Adzuki.CustomConfirm({
					title  : 'Change soft date?',
					content: 'Would you like to change the Final Soft Payment Date for this component from ' + formatted_soft_date + ' to ' + formatted_new_soft_date + ' (' + parseInt($soft_payment_date.data('soft-date-days')) + ' days before the Final Payment Date)? Click \'Yes\' to update the Final Payment Soft Date or \'No\' to keep the current Final Payment Soft Date.',
					confirm: function confirm() {
						soft_payment_date.date(new_soft_payment_date);
						// return true;
					}
				});
			}
		});

		// when departure datepicker changes,
		// update the corresponding arrival datepicker
		// If the train is roundtrip then update the return datepickers as well
		$('#' + label_name + '-departure-0-departure_date').on('dp.change', function onDepartureDpChange(event)
		{
			if (event.date) {
				$('#' + label_name + '-departure-0-arrival_date')
					.data('DateTimePicker')
					.date(event.date);

				if (p2p_type === 'roundtrip') {
					$('#' + label_name + '-return-0-departure_date')
						.data('DateTimePicker')
						.date(event.date);

					$('#' + label_name + '-return-0-arrival_date')
						.data('DateTimePicker')
						.date(event.date);
				}
			}
		});

		// if roundtrip, then the return datepicker should also change on its own
		$('#' + label_name + '-return-0-departure_date').on('dp.change', function onReturnDpChange(event)
		{
			if (event.date) {
				$('#' + label_name + '-return-0-arrival_date')
					.data('DateTimePicker')
					.date(event.date);
			}
		});

		// When editing a rail, add events when the button
		// to remove a connection is clicked
		$form.on('click', '.close-train', function onCloseTrainClick(event)
		{
			event.preventDefault();
			closeConnectingTrain($(this), event);
		});

		addConnectingTrainEvent();


		$form.on('click', '.station-lookup-toggle', function toggleStationLookup(e) {
			var $self = $(this),
			    $parent = $self.parents('.row.connection');
			e.preventDefault();

			if ($self.data('enabled') === 0) {
				$self.data('enabled', 1).html($self.data('enabled-text'));
				enableGoogleStationLookups($parent.find('.google-places'));
			} else {
				$self.data('enabled', 0).html($self.data('disabled-text'));
				$parent.find('.google-city-search').val('').off().removeData('typeahead');
				$parent.find('.google-station-search').off();
				$parent.find('.city-lookup').addClass('hidden');
				$parent.find('input.google-station-search').prop('disabled', false).removeData('typeahead');
			}
		});


		function enableGoogleStationLookups($el)
		{
			var $parent  = $el.parents('.city-lookup'),
			    $station = $parent.next('.station').find('input.google-station-search');

			// rail station typeahead stuff
			Adzuki.GooglePlaces($el);

			// set bounds on station search, and enable it
			$el.find('.google-city-search').on('gp.selected', function enableStationSearch(e, place, location) {
				// set coords on departure station to bound station searches geographically
				var $station_search = $(this).parents('.form-group').next('.station').find('input.google-station-search');

				$station_search.data({
					lat: location.lat,
					lng: location.lng,
				});

				$station_search.prop('disabled', false);
			});

			// station search
			Adzuki.Typeahead($station, function source(term, display, $self) {
				Adzuki.Ajax.post('/Searches/google', {
					use_location: true,
					type        : 'nearbySearch',
					types       : 'train_station',
					term        : $self.val(),
					coord       : {
						lat: $self.data('lat'),
						lng: $self.data('lng'),
					}
				}).then(function success(response) {
					$self.removeClass('ajax-spinner');

					if (response.results) {
						display(response.results);
					} else {
						display([{name: "No results found."}]);
					}
				});
			});

			$parent.removeClass('hidden');
			$station.val('').prop('disabled', true);
		}

		/**
		 * When clicking the "Add connecting train" button.
		 *
		 * @return {void}
		 */
		function addConnectingTrainEvent()
		{
			$('.connecting-train').off().click(function onConnectingTrainClick(event)
			{
				var connection_type    = $(event.target).data('type');
				var connection_markup  = $('.connection').first().clone();
				var $google_link       = connection_markup.find('.station-lookup-toggle');
				var copy_details_label = 'Copy train information from ';
				var connection_parent  = null;
				var leg_index          = null;
				var leg_text           = '';
				var name_field         = '';
				var id_field           = '';

				event.preventDefault();

				// find out where to insert this connection (departure or return)
				if (connection_type === 'departure') {
					connection_parent = departure_container.find('.connection').parent();
				} else {
					connection_parent = return_container.find('.connection').parent();
				}

				// figure out the train number
				leg_index = $('.connection[data-type="' + connection_type + '"]').length;
				leg_text  = 'TRAIN ' + (leg_index + 1) + ':';

				// set data attributes for the created connecting train
				connection_markup.attr('data-index', leg_index);
				connection_markup.attr('data-type', connection_type);
				connection_markup.find('.train-number').html(leg_text);

				// show close button
				connection_markup.find('.close-train')
								 .parent().parent().removeClass('hidden');

				// update index for the id and name on the form fields
				id_field   = label_name + '-' + connection_type + '-' + leg_index;
				name_field = form_name + '[' + connection_type + '][' + leg_index + ']';

				// show the copy details checkbox and update the text
				// of which train details are we copying
				connection_markup.find('.copy-details').parent()
								 .parent().removeClass('hidden');
				connection_markup.find('.copy-details').parent()
								 .next()
								 .html(copy_details_label + 'Train ' + leg_index);
				connection_markup.find('.copy-details')
								 .attr('id', id_field + '-copy_details');
				connection_markup.find('.copy-details')
								 .parent().next()
								 .attr('for', id_field + '-copy_details');
				connection_markup.find('.copy-details')
								 .attr('data-index', leg_index);
				connection_markup.find('.copy-details')
								 .attr('data-type', connection_type);
				connection_markup.find('.copy-details').first()
								 .on('click', function onCopyDetailsCheckboxClick(event)
				{
					copyTrainDetails($(this));
				});

				// update form fields: label "for", "id" and input "name"
				// this way they'll be sumbitted under their own index
				// company
				connection_markup.find('.field-company label')
								 .attr('for', id_field + '-company');
				connection_markup.find('.field-company select')
								 .attr('id', id_field + '-company');
				connection_markup.find('.field-company select')
								 .attr('name', name_field + '[company]');

				// train number
				connection_markup.find('.field-train-number label')
								 .attr('for', id_field + '-train_number');
				connection_markup.find('.field-train-number input[type="text"]')
								 .attr('id', id_field + '-train_number')
								 .attr('name', name_field + '[train_number]')
								 .val('');

				// class of service
				connection_markup.find('.field-class-of-service label')
								 .attr('for', id_field + '-class_of_service');
				connection_markup.find('.field-class-of-service input[type="text"]')
								 .attr('id', id_field + '-class_of_service')
								 .attr('name', name_field + '[class_of_service]')
								 .val('');

				// seats
				connection_markup.find('.field-seats label')
								 .attr('for', id_field + '-seats');
				connection_markup.find('.field-seats input[type="text"]')
								 .attr('id', id_field + '-seats')
								 .attr('name', name_field + '[seats]')
								 .val('');

				// departure station
				connection_markup.find('.field-departure-station label')
								 .attr('for', id_field + '-departure_station');
				connection_markup.find('.field-departure-station input[type="text"]')
								 .attr('id', id_field + '-departure_station')
								 .attr('name', name_field + '[departure_station]')
								 .val('');

				// departure date/time
				// The hidden fields are being removed cause they'll be re-added
				// by the Adzuki.DateTimePicker()
				connection_markup.find('.field-departure-datetime label')
								 .attr('for', id_field + '-departure_datetime');
				connection_markup.find('.field-departure-datetime input[type="text"][id$="date"]')
								 .attr('id', id_field + '-departure_date')
								 .attr('name', name_field + '[departure_date]')
								 .attr('type', 'date')
								 .data('value', '');
				connection_markup.find('.field-departure-datetime input[type="text"][id$="time"]')
								 .attr('id', id_field + '-departure_time')
								 .attr('name', name_field + '[departure_time]')
								 .attr('type', 'time')
								 .data('value', '');
				connection_markup.find('.field-departure-datetime input[type="hidden"]')
								 .remove();

				// arrival station
				connection_markup.find('.field-arrival-station label')
								 .attr('for', id_field + '-arrival_station');
				connection_markup.find('.field-arrival-station input[type="text"]')
								 .attr('id', id_field + '-arrival_station')
								 .attr('name', name_field + '[arrival_station]')
								 .val('');

				// arrival date/time
				// The hidden fields are being removed cause they'll be re-added
				// by the Adzuki.DateTimePicker()
				connection_markup.find('.field-arrival-datetime label')
								 .attr('for', id_field + '-arrival_datetime');
				connection_markup.find('.field-arrival-datetime input[type="text"][id$="date"]')
								 .attr('id', id_field + '-arrival_date')
								 .attr('name', name_field + '[arrival_date]')
								 .attr('type', 'date')
								 .data('value', '');
				connection_markup.find('.field-arrival-datetime input[type="text"][id$="time"]')
								 .attr('id', id_field + '-arrival_time')
								 .attr('name', name_field + '[arrival_time]')
								 .attr('type', 'time')
								 .data('value', '');
				connection_markup.find('.field-arrival-datetime input[type="hidden"]')
								 .remove();

				// insert the connecting train
				connection_parent.append('<hr>');
				connection_parent.append(connection_markup);

				// re-initialize datepickers
				$.each(connection_markup.find('input[type="date"]'), function reInitDatePicker(i, el)
				{
					$(el).removeData('DateTimePicker');
					$(el).off();
					Adzuki.DateTimePicker($(el));
					$(el).data('DateTimePicker')
						.date(null);
					$(el).siblings(Adzuki.FaIcon.getIconSelector('close')).addClass('hidden');
				});

				// re-initialize timepickers
				$.each(connection_markup.find('input[type="time"]'), function reInitTimePicker(i, el)
				{
					$(el).removeData('DateTimePicker');
					$(el).off();
					Adzuki.DateTimePicker($(el), 'hh:mm a', 'HH:mm:ss');
					$(el).data('DateTimePicker')
						.date(null);
					$(el).siblings(Adzuki.FaIcon.getIconSelector('close')).addClass('hidden');
				});

				// when departure datepicker changes,
				// update the corresponding arrival datepicker
				$('#' + id_field + '-departure_date').on('dp.change', function onDepartureDpChange(event)
				{
					if (event.date) {
						$('#' + id_field + '-arrival_date')
							.data('DateTimePicker')
							.date(event.date);
					}
				});

				// reset station lookup
				$google_link.data('enabled', 0).html($google_link.data('disabled-text'));
				connection_markup.find('.google-city-search').val('').off().removeData('typeahead');
				connection_markup.find('.google-station-search').off();
				connection_markup.find('.city-lookup').addClass('hidden');
				connection_markup.find('input.google-station-search').prop('disabled', false).removeData('typeahead');
			});
		}

		/**
		 * Remove a connecting train, this method is called
		 * when a click to the close button is triggered
		 * 
		 * @param  {jQuery} close_btn
		 * @param  {Object} event
		 * 
		 * @return {void}
		 */
		function closeConnectingTrain($close_btn, event)
		{
			var $connection;
			Adzuki.CustomConfirm({
				body   : 'Are you sure you want to remove this connecting train?',
				confirm: function removeConnectingTrain() {
					$connection = $close_btn.parents('.connection');
					$connection.prev().remove(); // remove the hr
					$connection.remove();
					updateConnectionLegs($close_btn.attr('data-type'));
				}
			});
		}

		/**
		 * Copy the train number, class of service and station details
		 * from the previous connection to the current clicked connection.
		 * 
		 * @param  {jQuery} $checkbox
		 * 
		 * @return {void}
		 */
		function copyTrainDetails($checkbox)
		{
			var type               = $checkbox.data('type');
			var index              = $checkbox.data('index');
			var company            = null;
			var train_number       = null;
			var class_of_service   = null;
			var departure_station  = null;
			var arrival_station    = null;
			var from_conn          = null;
			var to_conn            = null;
			var from_conn_selector = '';
			var to_conn_selector   = '';
			var arrival_date       = null;

			if ($checkbox.is(':checked')) {
				// I'm copying the details from the departure train
				// into the return train, do nothing else after this
				if (type === 'return' && index === 0) {
					from_conn = departure_container.find('.connection').first();
					to_conn   = return_container.find('.connection').first();

					// copy company
					company = from_conn.find('.field-company select').val();
					to_conn.find('.field-company select').val(company);

					// copy train number
					train_number = from_conn.find('.field-train-number input[type="text"]').val();
					to_conn.find('.field-train-number input[type="text"]').val(train_number);

					// copy class of service
					class_of_service = from_conn
						.find('.field-class-of-service input[type="text"]')
						.val();
					to_conn
						.find('.field-class-of-service input[type="text"]')
						.val(class_of_service);

					// copy departure station
					departure_station = from_conn
						.find('.field-departure-station input[type="text"]')
						.val();
					arrival_station = from_conn
						.find('.field-arrival-station input[type="text"]')
						.val();
					to_conn
						.find('.field-arrival-station input[type="text"]')
						.val(departure_station)
						.prop('disabled', false);
					to_conn
						.find('.field-departure-station input[type="text"]')
						.val(arrival_station)
						.prop('disabled', false);

					return;
				}

				// copying details from Train x to Train y in the same leg
				from_conn_selector = '.connection[data-index="' + (index - 1) + '"][data-type="' + type + '"]';
				to_conn_selector   = '.connection[data-index="' + index + '"][data-type="' + type + '"]';

				// if we are copying the details from train 1
				// find the correct train container to copy details from
				if ($(document).find(from_conn_selector).length === 0) {
					if (type === 'departure') {
						from_conn = departure_container.find('.connection').first();
					} else {
						from_conn = return_container.find('.connection').first();
					}
				} else {
					from_conn = $(document)
						.find(from_conn_selector)
						.first();
				}

				// Just copying "Arriving To" data from Train x 
				// into the "Departing From" data from Train (x + 1)
				to_conn = $(document)
					.find(to_conn_selector)
					.first();

				// copy company
				company = from_conn.find('.field-company select').val();
				to_conn.find('.field-company select').val(company);

				// copy train number
				train_number = from_conn.find('.field-train-number input[type="text"]').val();
				to_conn.find('.field-train-number input[type="text"]').val(train_number);

				// copy class of service
				class_of_service = from_conn
					.find('.field-class-of-service input[type="text"]')
					.val();
				to_conn
					.find('.field-class-of-service input[type="text"]')
					.val(class_of_service);

				// copy departure station
				arrival_station = from_conn
					.find('.field-arrival-station input[type="text"]')
					.val();
				to_conn
					.find('.field-departure-station input[type="text"]')
					.val(arrival_station)
					.prop('disabled', false);

				// get the arrival date from the previous leg,
				// and set departure/arrival dates on this leg to that value :D
				arrival_date = from_conn
					.find('.field-arrival-datetime input[id$="date"]')
					.val();

				to_conn
					.find('.field-departure-datetime input[id$="date"]')
					.data('DateTimePicker').date(arrival_date);

				to_conn
					.find('.field-arrival-datetime input[id$="date"]')
					.data('DateTimePicker').date(arrival_date);
			}
		}

		/**
		 * Update the train number on all of the existing connections
		 * for the specified type (departure or return)
		 * 
		 * @param  {string} connection_type
		 * 
		 * @return {void}
		 */
		function updateConnectionLegs(connection_type)
		{
			// update the train number on all of the connection elements
			$('.connection[data-type="' + connection_type + '"]').each(function onEachConnectionElement(i, elem) {
				// change transfer number
				$(elem).find('.train-number')
					   .html('TRAIN ' + String(i + 1) + ':');

				// change data attributes
				$(elem).attr('data-index', String(i));
				$(elem).find('.close-train')
					   .attr('data-index', String(i));
			});
		}

		/**
		 * When clicking on copy train info checkbox 
		 * on the return train 1
		 *
		 * @return {void}
		 */
		function addReturnTrainCheckboxEvent()
		{
			var selector = '#' + label_name + '-return-0-copy_details';

			$(selector).off().on('click', function onCopyDetailsCheckboxClick(event)
			{
				copyTrainDetails($(this));
			});
		}

		/**
		 * It shows the copy details checkbox on the return train 1
		 * 
		 * @return {void}
		 */
		function showReturnTrainCheckbox()
		{
			var selector = '#' + label_name + '-return-0-copy_details';

			$(selector).parent().parent().removeClass('hidden');
		}
	};

}(jQuery, window.Adzuki || {}));
